import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10c419f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding":"0.7rem"} }
const _hoisted_2 = { class: "border-btm" }
const _hoisted_3 = { class: "good-con" }
const _hoisted_4 = { class: "cls-flex" }
const _hoisted_5 = { class: "good-title one-hide" }
const _hoisted_6 = { class: "cls-con num-con" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "累计金额", -1))
const _hoisted_8 = { style: {"font-weight":"bold"} }
const _hoisted_9 = { class: "cls-con num-con" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "优惠金额", -1))
const _hoisted_11 = { style: {"font-weight":"bold"} }
const _hoisted_12 = { class: "cls-con num-con" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "实付金额", -1))
const _hoisted_14 = { style: {"font-weight":"bold"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_search, {
      modelValue: _ctx.reqData.text,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reqData.text) = $event)),
      shape: "round",
      placeholder: "订单编码、服务名称、商品名称等",
      onSearch: _ctx.search_click
    }, null, 8, ["modelValue", "onSearch"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_list, {
        loading: _ctx.loading,
        "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loading) = $event)),
        finished: _ctx.finished,
        "finished-text": _ctx.list.length ? '没有更多了' : '暂无明细',
        error: _ctx.error,
        "onUpdate:error": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.error) = $event)),
        "error-text": "请求失败，点击重新加载",
        onLoad: _ctx.req_items
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.orderCode,
              class: "white-radius item-con"
            }, [
              _createElementVNode("div", null, "订单编号：" + _toDisplayString(item.orderCode), 1),
              _createElementVNode("div", _hoisted_2, "创建时间：" + _toDisplayString(item.createDate), 1),
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.goods, (good) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(good.goodsName), 1),
                    _createElementVNode("div", null, "x" + _toDisplayString(good.goodsNum), 1)
                  ]))
                }), 256))
              ]),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, "￥" + _toDisplayString(item.allMoney), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, "￥" + _toDisplayString(item.discountMoney), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, "￥" + _toDisplayString(item.payMoney), 1)
              ])
            ]))
          }), 128))
        ]),
        _: 1
      }, 8, ["loading", "finished", "finished-text", "error", "onLoad"])
    ])
  ], 64))
}